import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { Card, Button, Row, Col, Form, Input, DatePicker } from 'antd';
import {
  SendOutlined,
} from '@ant-design/icons';
import { _ROUTES, _CONST } from '../../constants/GlobalConst';
import { _notify } from "../../helpers/Utils";
import * as reduxActions from "../../constants/ActionTypes";

class TeacherRegister extends React.Component {

  constructor(props) {
    super(props);

    const { match: { params: { Id } } } = props;
    this.state = {
      teacher_account_uuid: Id,
      teacher: {},
      mode: !_.isEmpty(Id) ? 'edit' : 'add',
    };

    this.formRef = React.createRef();
  }

  componentDidMount() {
    const { mode, teacher_account_uuid } = this.state;
    const { getTeacherAccountRequest } = this.props;

    mode === 'edit' && getTeacherAccountRequest({ uuid: teacher_account_uuid });
  }

  componentDidUpdate(prevProps) {
    const { create, edit, view, history } = this.props;

    if (prevProps.create !== create) {
      const { result } = create;
      if (result.success) {
        _notify({ type: 'success', description: 'Teacher Account is successfully created' });
        history.push(_ROUTES.PATH_TEACHERS);
      } else {
        _notify({ type: 'error', description: _.get(result, 'response.message', '') });
      }
    }

    if (prevProps.edit !== edit) {
      const { result } = edit;
      if (result.success) {
        _notify({ type: 'success', description: 'Teacher Account is successfully updated' });
        history.push(_ROUTES.PATH_TEACHERS);
      } else {
        _notify({ type: 'error', description: _.get(result, 'response.message', '') });
      }
    }

    if (prevProps.view !== view) {
      const { result } = view;
      if (result.success) {
        const teacher = _.get(result, 'response.data', {});
        this.setState({
          teacher
        }, () => {
          this.formRef.current.setFieldsValue({
            email: _.get(teacher, 'email', ''),
            phone_number: _.get(teacher, 'phone_number', ''),
            fullname: _.get(teacher, 'profile.fullname', ''),
            date_of_birth: teacher.profile.date_of_birth ? moment(teacher.profile.date_of_birth) : null,
          });
        });
      } else {
        _notify({ type: 'error', description: _.get(result, 'response.message', '') });
        history.push(_ROUTES.PATH_TEACHERS);
      }
    }

  }

  _handleFormFinish = (values) => {
    const { mode, teacher_account_uuid } = this.state;
    const { createTeacherAccountRequest, editTeacherAccountRequest } = this.props;

    if (!this._checkCustomFieldValidation(values)) {
      const params = {
        ..._.omit(values, ['confirm_password']),
        date_of_birth: values.date_of_birth ? moment(values.date_of_birth).format(_CONST.DATE_FORMAT) : null,
      };

      mode === 'add'
        ? createTeacherAccountRequest(params)
        : editTeacherAccountRequest({ uuid: teacher_account_uuid, data: params });
    }
  }

  _handleFormFinishFailed = ({ values }) => {
    this._checkCustomFieldValidation(values);
  }

  _checkCustomFieldValidation = (values) => {
    const { mode } = this.state;
    let hasError = false;

    if (mode === 'add' && values.password !== values.confirm_password) {
      hasError = true;
      this.formRef.current.setFields([{
        name: 'confirm_password',
        errors: [`Confirm Passowrd doesn't match with Password field`],
      }]);
    }

    return hasError;
  }

  render() {
    const { mode } = this.state;

    return (
      <React.Fragment>
        <Card
          className="sk-card"
          title={`${mode === 'add' ? `Register` : `Update`} Teacher Account`}>
          <Form
            ref={this.formRef}
            layout="vertical"
            scrollToFirstError
            onFinish={this._handleFormFinish}
            onFinishFailed={this._handleFormFinishFailed}
          >
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                <Form.Item name="email" label="Email"
                  rules={[
                    { type: 'email', message: 'Email is not valid' },
                    { required: true, message: 'Email is required' }
                  ]}>
                  <Input size="large" placeholder="Email" maxLength={50} />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                <Form.Item name="phone_number" label="Phone Number"
                  rules={[
                    { required: true, message: 'Phone Number is required' }
                  ]}>
                  <Input size="large" placeholder="Phone Number" maxLength={15} />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                <Form.Item name="fullname" label="Full Name"
                  rules={[
                    { required: true, message: 'Full Name is required' }
                  ]}>
                  <Input size="large" placeholder="Teacher's Full Name" maxLength={50} />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                <Form.Item name="date_of_birth" label="Date of Birth">
                  <DatePicker
                    size="large"
                    className="full-width"
                    disabledDate={(current) => current && current > moment().startOf('day').add(1, 'day')}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                <Form.Item name="password" label="Password"
                  rules={[
                    { required: mode === 'add', message: 'Password is required' },
                    { min: 6, message: 'Password must be greater or equal to 6 characters.' },
                  ]}>
                  <Input type="password" size="large" placeholder="Password" maxLength={50} />
                </Form.Item>
              </Col>
              {mode === 'add' && <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                <Form.Item name="confirm_password" label="Confirm Password"
                  rules={[
                    { required: true, message: 'Confirm Password is required' },
                    { min: 6, message: 'Password must be greater or equal to 6 characters.' },
                  ]}>
                  <Input type="password" size="large" placeholder="Confirm Password" maxLength={50} />
                </Form.Item>
              </Col>}
            </Row>
            <Row>
              <Col xs={{ span: 24 }} sm={{ span: 24 }}>
                <div className="sk-button-group">
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    icon={<SendOutlined />}>{`${mode === 'add' ? `Register` : `Update`}`}</Button>
                  <Button
                    size="large"
                    onClick={() => this.props.history.push(_ROUTES.PATH_TEACHERS)}
                  >Back</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  view: _.get(state, 'teacher.view', {}),
  create: _.get(state, 'teacher.create', {}),
  edit: _.get(state, 'teacher.edit', {}),
});

const mapDispatchToProps = (dispatch) => ({
  getTeacherAccountRequest: payload => dispatch({ type: reduxActions.GET_TEACHER_ACCOUNT_REQUEST, payload }),
  createTeacherAccountRequest: payload => dispatch({ type: reduxActions.CREATE_TEACHER_ACCOUNT_REQUEST, payload }),
  editTeacherAccountRequest: payload => dispatch({ type: reduxActions.EDIT_TEACHER_ACCOUNT_REQUEST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeacherRegister);
